import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Transition as _Transition } from "vue"
import _imports_0 from '../public/logo.png'


const _hoisted_1 = { class: "text-center pt-1" }
const _hoisted_2 = {
  key: 0,
  class: "border-b-2 border-primary pb-2"
}
const _hoisted_3 = {
  key: 1,
  src: _imports_0,
  alt: "Wonder Logo",
  class: "h-7 m-auto"
}
const _hoisted_4 = { class: "flex flex-col justify-between h-full pt-4" }
const _hoisted_5 = { slot: "content" }
const _hoisted_6 = { class: "font-bold antonio uppercase" }
const _hoisted_7 = { class: "antonio" }
const _hoisted_8 = {
  id: "main",
  class: "w-full"
}
const _hoisted_9 = {
  key: 0,
  class: "border-b-2 border-primary w-40 p-1"
}
const _hoisted_10 = {
  key: 1,
  src: _imports_0,
  alt: "Wonder Logo",
  class: "h-6 m-auto"
}

import router from '@/router'
import {useAuthStore} from '@/stores/auth.store'
import {fade} from '@/tools/animations'
import {Menu} from '@/types/Menu'
import TwcLogo from '@/views/components/TwcLogo.vue'
import {
  IonAccordion,
  IonAccordionGroup,
  IonApp,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonMenu,
  IonMenuButton,
  IonRouterOutlet,
  IonSplitPane,
  IonTitle,
  IonToolbar
} from '@ionic/vue'
import {AuthSession, Role} from '@wonder/entities'
import {
  cashOutline,
  colorPaletteOutline,
  cubeOutline,
  hardwareChipOutline,
  keyOutline,
  peopleOutline,
  personCircle,
  pricetagsOutline,
  storefrontOutline,
  timeOutline
} from 'ionicons/icons'
import {storeToRefs} from 'pinia'
import {computed, ComputedRef, Ref, ref, watch} from 'vue'
import {useI18n} from 'vue-i18n'
import {useRoute} from 'vue-router'
import {useMq} from 'vue3-mq'
import {roleHome} from '@/tools/roleHome'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const {t} = useI18n()
const route = useRoute()
const mq = useMq()

const authStore = useAuthStore()

const {authSession} = storeToRefs(authStore)

const compact = ref(false)

const home = computed(() => roleHome(authSession.value))

const menu: Ref<{ $el: HTMLIonMenuElement }> = ref()

const adminMenu: Ref<Menu> = ref({
  pages: [{
    icon: keyOutline,
    name: t('licenses'),
    path: '/licenses'
  }, {
    icon: storefrontOutline,
    name: t('clinics'),
    path: '/clinics'
  }, {
    icon: colorPaletteOutline,
    name: t('flavors'),
    path: '/flavors'
  }, {
    icon: cubeOutline,
    name: t('apps'),
    path: '/apps'
  }, {
    icon: peopleOutline,
    name: t('accounts'),
    path: '/accounts'
  }],
  categories: [{
    icon: timeOutline,
    name: t('ppt'),
    pages: [{
      name: 'prices',
      path: '/prices',
      icon: cashOutline
    }, {
      name: 'discounts',
      path: '/discounts',
      icon: pricetagsOutline
    }]
  }]
})

const franchiseeMenu: ComputedRef<Menu> = computed(() => ({
  pages: [{
    icon: storefrontOutline,
    name: t('clinics'),
    path: '/clinics'
  }]
}))

const ownerMenu: ComputedRef<Menu> = computed(() => ({
  pages: [{
    icon: hardwareChipOutline,
    name: t('devices'),
    path: '/devices'
  }]
}))

const userMenu: ComputedRef<Menu> = computed(() => {
  if (!authSession.value) return {pages: []}
  if (authSession.value.roles.includes(Role.ADMIN)) {
    return adminMenu.value
  } else if (authSession.value.roles.includes(Role.OWNER) || authSession.value.roles.includes(Role.FRANCHISEE) || authSession.value.roles.includes(Role.DISTRIBUTOR)) {
    const pages = []
    if (authSession.value.roles.includes(Role.OWNER) || authSession.value.roles.includes(Role.DISTRIBUTOR)) {
      pages.push(...ownerMenu.value.pages)
    }
    if (authSession.value.roles.includes(Role.FRANCHISEE)) {
      pages.push(...franchiseeMenu.value.pages)
    }
    return {pages}
  }
})

const close = () => {
  menu.value.$el.close()
}

const refresh = () => {
  router.go(0)
}

const isActive = (path: string) => new RegExp('^' + path + '/').test(route.path + '/')

watch(() => authSession.value, (session: AuthSession) => {
  if (session?.roles.includes(Role.FRANCHISEE)) {
    document.body.classList.add('twc')
  } else {
    document.body.classList.remove('twc')
  }
}, {immediate: true})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_unref(authSession))
            ? (_openBlock(), _createBlock(_unref(IonSplitPane), {
                key: 0,
                "content-id": "main"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonMenu), {
                    "content-id": "main",
                    ref_key: "menu",
                    ref: menu
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonHeader), { class: "overflow-visible" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonToolbar), { class: "relative" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_1, [
                                _createVNode(_unref(IonButton), {
                                  "router-link": home.value,
                                  "router-direction": "back",
                                  fill: "clear",
                                  slot: "start",
                                  class: "mt-4 lg:mt-8",
                                  onClick: close
                                }, {
                                  default: _withCtx(() => [
                                    (_unref(authSession).twc)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                          _createVNode(TwcLogo, { class: "h-7" })
                                        ]))
                                      : (_openBlock(), _createElementBlock("img", _hoisted_3))
                                  ]),
                                  _: 1
                                }, 8, ["router-link"])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonContent), { fullscreen: true }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_unref(IonList), { lines: "none" }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userMenu.value.pages, (item) => {
                                  return (_openBlock(), _createBlock(_unref(IonItem), {
                                    key: item.path,
                                    button: "",
                                    "router-link": item.path,
                                    "router-direction": isActive(item.path) && 'back',
                                    "router-animation": !isActive(item.path) && _unref(fade),
                                    class: _normalizeClass([{active: isActive(item.path)}, "activatable"]),
                                    detail: false,
                                    onClick: close
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(IonIcon), {
                                        icon: item.icon,
                                        slot: "start"
                                      }, null, 8, ["icon"]),
                                      _createVNode(_unref(IonLabel), { class: "uppercase antonio text-xl" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.name), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["router-link", "router-direction", "router-animation", "class"]))
                                }), 128)),
                                _createVNode(_unref(IonAccordionGroup), null, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userMenu.value.categories, (category) => {
                                      return (_openBlock(), _createBlock(_unref(IonAccordion), {
                                        key: category.name
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(IonItem), { slot: "header" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(IonIcon), {
                                                icon: category.icon,
                                                slot: "start"
                                              }, null, 8, ["icon"]),
                                              _createVNode(_unref(IonLabel), { class: "uppercase antonio text-xl" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(category.name), 1)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createElementVNode("div", _hoisted_5, [
                                            _createVNode(_unref(IonList), { lines: "none" }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.pages, (item) => {
                                                  return (_openBlock(), _createBlock(_unref(IonItem), {
                                                    key: item.path,
                                                    button: "",
                                                    "router-link": item.path,
                                                    "router-direction": isActive(item.path) && 'back',
                                                    "router-animation": !isActive(item.path) && _unref(fade),
                                                    class: _normalizeClass([{active: isActive(item.path)}, "activatable"]),
                                                    detail: false,
                                                    onClick: close
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(IonIcon), {
                                                        icon: item.icon,
                                                        slot: "start",
                                                        class: "ml-4"
                                                      }, null, 8, ["icon"]),
                                                      _createVNode(_unref(IonLabel), { class: "uppercase antonio text-xl" }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(item.name), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["router-link", "router-direction", "router-animation", "class"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonItem), {
                              lines: "none",
                              button: "",
                              detail: false,
                              "router-link": "/account",
                              "router-animation": _unref(fade),
                              onClick: close,
                              class: _normalizeClass([{active: isActive('/account')}, "activatable"])
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonIcon), {
                                  icon: _unref(personCircle),
                                  size: "large",
                                  slot: "start"
                                }, null, 8, ["icon"]),
                                _createVNode(_unref(IonLabel), null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(authSession).name), 1),
                                    _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(authSession).email), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["router-animation", "class"])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 512),
                  _createElementVNode("div", _hoisted_8, [
                    (_unref(mq).mdMinus)
                      ? (_openBlock(), _createBlock(_unref(IonHeader), {
                          key: 0,
                          translucent: true
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonToolbar), { class: "py-1" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonButtons), {
                                  slot: "start",
                                  class: "pl-1"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonMenuButton), { color: "light" })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(IonTitle), { class: "p-0" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonButton), {
                                      fill: "clear",
                                      class: "logo-button -ml-3",
                                      "router-link": home.value,
                                      "router-direction": "back"
                                    }, {
                                      default: _withCtx(() => [
                                        (_unref(authSession).roles.includes('FRANCHISEE'))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                              _createVNode(TwcLogo)
                                            ]))
                                          : (_openBlock(), _createElementBlock("img", _hoisted_10))
                                      ]),
                                      _: 1
                                    }, 8, ["router-link"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_unref(IonRouterOutlet))
                  ])
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_unref(IonRouterOutlet), { key: 1 }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})